import { black, blueLight, gray5, white } from "assets/styleUtils";

interface IButton {
  onClick: () => void;
  text: string;
  color?: string;
}

export default function SelectModal({ buttonList }: { buttonList: IButton[] }) {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        width: "100%",
      }}
    >
      {buttonList.map(({ color, onClick, text }, index) => {
        return (
          <>
            <div
              key={index}
              onClick={onClick}
              style={{
                width: "100%",
                height: "50px",
                backgroundColor: white,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderBottom:
                  index !== buttonList.length ? `1px solid ${gray5}` : ``,
              }}
            >
              <div style={{ color: color || blueLight, fontSize: "16px" }}>
                {text}
              </div>
            </div>
          </>
        );
      })}
    </div>
  );
}
